"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContentTypeSelector = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _DropDown = _interopRequireDefault(require("@civicplus/preamble/lib/DropDown/DropDown"));

var _react = _interopRequireWildcard(require("react"));

var _sdk = require("@civicplus/hcms-api-sdk/dist/sdk");

var _classnames = _interopRequireDefault(require("classnames"));

var _Alert = require("../Utility/Alert");

var _sortBy = _interopRequireDefault(require("lodash/sortBy"));

var ContentTypeSelector = function ContentTypeSelector(props) {
  var _props$helperText;

  var _useState = (0, _react.useState)([]),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      contentTypes = _useState2[0],
      setContentTypes = _useState2[1];

  var _useState3 = (0, _react.useState)(),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      value = _useState4[0],
      setValue = _useState4[1];

  (0, _react.useEffect)(function () {
    function load() {
      return _load.apply(this, arguments);
    }

    function _load() {
      _load = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var service, types;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                service = new _sdk.ContentTypesApi(props.config);
                _context.next = 3;
                return service.getContentTypes(props.config.appName);

              case 3:
                types = _context.sent;
                //Currently the sdk does not have the orderBy prop. This order by can be removed once that is implemented on the sdk
                setContentTypes((0, _sortBy["default"])(types.items, [function (p) {
                  return p.name.toLowerCase();
                }]));

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _load.apply(this, arguments);
    }

    (0, _Alert.alertOnError)("Failed to load Content Types.", load);
  }, [props.config]);
  (0, _react.useEffect)(function () {
    function load() {
      return _load2.apply(this, arguments);
    }

    function _load2() {
      _load2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
        var existing;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                existing = contentTypes.find(function (type) {
                  return type.name === props.value;
                });
                setValue(existing);

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
      return _load2.apply(this, arguments);
    }

    (0, _Alert.alertOnError)("Failed to set Content Type due to value not being found in list of Content Types retrieved.", load);
  }, [contentTypes, props.value]);
  return /*#__PURE__*/_react["default"].createElement(_DropDown["default"], {
    isInDialog: props.isInDialog,
    className: (0, _classnames["default"])("prmbl-contentTypeSelector", props.className),
    label: "Content Type",
    value: value != null ? {
      label: value.properties.label ? value.properties.label : value.name,
      id: value.id
    } : undefined,
    helperText: (_props$helperText = props.helperText) !== null && _props$helperText !== void 0 ? _props$helperText : "Select a Content Type to begin.",
    onChange: function onChange(e) {
      var _props$onChange;

      var type = contentTypes.find(function (w) {
        return w.id === e.value;
      });
      setValue(type);
      type && ((_props$onChange = props.onChange) === null || _props$onChange === void 0 ? void 0 : _props$onChange.call(props, type));
    },
    disabled: props.disabled,
    options: contentTypes.map(function (s) {
      return {
        label: s.properties.label ? s.properties.label : s.name,
        value: s.id
      };
    })
  });
};

exports.ContentTypeSelector = ContentTypeSelector;